import React, { useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";
import copy from "copy-to-clipboard";

import { PageBase } from "../PageBase";
import { generateReport } from "./utils/generateReport";
import { getDefaultInputDate } from "./utils/getDefaultInputDate";
import { prepareTasksApiToUse } from "../../utils/server/GoogleTasks";

import BEM from "./ReportGenerator.module.scss";
import { useEffect } from "react";

const preparationInfo = `1. Everyday fill [this form](https://forms.gle/ATztYMR8i331tAmw6) (click to open it).
2. Download form \`.csv\` data from [here](https://docs.google.com/forms/d/1Vii87x6bj9SkkDdML2eDFcKFhT1pHao7TKJCDGDhA6Y/edit#responses)
3. Unarchive and convert from \`.csv\` to \`.json\` [here](https://csvjson.com/csv2json)
4. Paste in \`Google form\` field below
5. Sync data from mobile:
    1. Open mobile app
    2. Close Obsidian desktop window
    3. Copy data from localStorage
    4. Open \`MY_PRODUCTIVITY_ASSIST_BACKUPS\` folder in mobile's obsidian
    5. Create file
    6. Paste it there
    7. Repeat step 5.1 - 5.5 for \`Food Plan\`, \`Routine\`, \`Accumulative\`, \`People Relationships\`
    8. Open DriveSync in mobile and sync data
    9. Open suitable subfolder in \`MY_PRODUCTIVITY_ASSIST_BACKUPS\` folder in Desktop's obsidian
    10. Paste data from each file to 'Food Plan', 'Routine', 'Accumulative', 'People Relationships' fields below
6. Click \`OPERATE\` button
7. Complete each day
    1. Copy days md text (see buttons below 'operate' button)
    2. Paste md text in suitable Obsidian's daily note (see calendar plugin for better navigation)
    3. Paste photos instead of red circles
    4. Link real files instead of [[]] and red circles
    5. Link real people's files where needed
8. Voyla`;

export const ReportGenerator = () => {
    const [googleForm, setGoogleForm] = useState("");
    const [foodPlan, setFoodPlan] = useState("");
    const [routine, setRoutine] = useState("");
    const [accumulative, setAccumulative] = useState("");
    const [relationships, setRelationships] = useState("");
    const [date, setDate] = useState(getDefaultInputDate());

    const [days, setDays] = useState("notclicked");

    useEffect(() => {
        prepareTasksApiToUse();
    }, []);

    const operateClickHandler = async () => {
        setDays("loading");

        if (foodPlan) {
            localStorage.setItem("plan/food", foodPlan);
        }

        if (routine) {
            localStorage.setItem("stats/routine", routine);
        }

        if (accumulative) {
            localStorage.setItem("stats/accumulative", accumulative);
        }

        if (relationships) {
            localStorage.setItem("stats/people", relationships);
        }

        const days = await generateReport(googleForm, new Date(date));

        setDays(days);
    };

    return (
        <div className={BEM.block}>
            <PageBase heading="Generate report">
                <ReactMarkdown
                    className={BEM.contentActually}
                    plugins={[remarkBreaks]}
                    children={preparationInfo}
                />
            </PageBase>

            <h2 className={BEM.globalTitle}>Data pasting and data getting</h2>

            <div className={BEM.row}>
                <h3 className={BEM.globalTitleL3}>Google Form</h3>
                <textarea
                    className={BEM.textAria}
                    value={googleForm}
                    onChange={(event) => setGoogleForm(event.target.value)}
                    name="googleForms"
                    id="fromGoogleForms"
                    cols="30"
                    rows="10"
                ></textarea>
            </div>

            <div className={BEM.row}>
                <h3 className={BEM.globalTitleL3}>Food Plan</h3>
                <textarea
                    className={BEM.textAria}
                    value={foodPlan}
                    onChange={(event) => setFoodPlan(event.target.value)}
                    name="foodPlan"
                    id="foodPlan"
                    cols="30"
                    rows="10"
                ></textarea>
            </div>

            <div className={BEM.row}>
                <h3 className={BEM.globalTitleL3}>Routine</h3>
                <textarea
                    className={BEM.textAria}
                    value={routine}
                    onChange={(event) => setRoutine(event.target.value)}
                    name="routine"
                    id="routine"
                    cols="30"
                    rows="10"
                ></textarea>
            </div>

            <div className={BEM.row}>
                <h3 className={BEM.globalTitleL3}>Accumulative</h3>
                <textarea
                    className={BEM.textAria}
                    value={accumulative}
                    onChange={(event) => setAccumulative(event.target.value)}
                    name="accumulative"
                    id="accumulative"
                    cols="30"
                    rows="10"
                ></textarea>
            </div>

            <div className={BEM.row}>
                <h3 className={BEM.globalTitleL3}>People Relationships</h3>
                <textarea
                    className={BEM.textAria}
                    value={relationships}
                    onChange={(event) => setRelationships(event.target.value)}
                    name="relationships"
                    id="relationships"
                    cols="30"
                    rows="10"
                ></textarea>
            </div>

            <div className={BEM.row}>
                <h3 className={BEM.globalTitleL3}>Start Date</h3>
                <input
                    type="date"
                    value={date}
                    onChange={(event) => setDate(event.target.value)}
                />
            </div>

            <div className={BEM.row}>
                <button
                    onClick={operateClickHandler}
                    className={BEM.operateBtn}
                >
                    OPERATE
                </button>
            </div>

            <div
                className={BEM.row}
                style={{ minHeight: "200px", marginBottom: "50px" }}
            >
                {days === "loading" && "Wait few sec..."}
                {days instanceof Array &&
                    days.map((day) => (
                        <button
                            key={day.date}
                            style={{
                                display: "block",
                                marginBottom: "7px",
                                cursor: "pointer",
                            }}
                            onClick={() => {
                                console.log(day.md);
                                if (copy(day.md)) {
                                    alert(
                                        `Day: ${day.date.getWeekDayName()} ${day.date.getDate()} ${day.date.getMonthName()}\nCopied successfully`,
                                    );
                                } else {
                                    alert("error");
                                }
                            }}
                        >
                            {day.date.getWeekDayName()}:{day.date.getDate()}{" "}
                            {day.date.getMonthName()}
                        </button>
                    ))}
            </div>
        </div>
    );
};
